import { forwardRef, useEffect, useLayoutEffect, useRef, useState } from 'react'
import { FontLoader } from './FontLoader'
import { canvasUtils } from '../../common/canvasUtils'
import { AlignGuidelines } from 'fabric-guideline-plugin'
import { fabric } from '../../common/fabricHistory'

export const Canvas = forwardRef(
    (
        {
            onObjectAdded,
            onObjectModified,
            onObjectRemoved,
            onSelectionCreated,
            onSelectionUpdated,
            onSelectionCleared,
            width,
            height,
            scale,
            canvasJSON,
        },
        ref
    ) => {
        const canvasEl = useRef(null)
        const canvasRef = useRef(null)
        const [fonts, setFonts] = useState(null)

        const loadCanvasJSON = () => {
            canvasRef.current.loadFromJSON(canvasJSON)
        }

        useLayoutEffect(() => {
            if (!canvasRef.current) {
                return
            }

            canvasRef.current.setDimensions({ width: width, height: height })
            if (scale) {
                canvasRef.current.setZoom(scale)
            }

            canvasRef.current.renderAll()
        }, [width, height, scale])

        useEffect(() => {
            const backgroundColor = canvasJSON
                ? canvasJSON.background
                : '#FFFFFF'
            canvasRef.current = new fabric.Canvas(canvasEl.current, {
                preserveObjectStacking: true,
                backgroundColor: backgroundColor,
                width: width,
                height: height,
            })

            const guideline = new AlignGuidelines({
                canvas: canvasRef.current,
            })
            guideline.init()

            if (scale) {
                canvasRef.current.setZoom(scale)
            }

            if (typeof ref === 'function') {
                ref(canvasRef.current)
            } else if (ref && typeof ref === 'object') {
                ref.current = canvasRef.current
            }

            if (canvasJSON) {
                let fontArr = canvasUtils.findAllFonts(canvasJSON)
                if (fontArr.length > 0) {
                    setFonts(fontArr)
                }
            }

            canvasRef.current.renderAll()
            canvasRef.current.on({
                'object:added': onObjectAdded,
                'object:modified': onObjectModified,
                'object:removed': onObjectRemoved,
                'selection:created': onSelectionCreated,
                'selection:updated': onSelectionUpdated,
                'selection:cleared': onSelectionCleared,
            })

            return () => {
                // NOTE: Async disposal is causing issues here in react. See: https://github.com/fabricjs/fabric.js/issues/8299 on React Compatibility
                canvasRef.current.dispose()
            }
        }, [canvasJSON])

        return (
            <div>
                <div>
                    {fonts && (
                        <FontLoader
                            fontDataArr={fonts}
                            onStatusChanged={loadCanvasJSON}
                        />
                    )}
                </div>
                <canvas
                    ref={canvasEl}
                    style={{ boxShadow: '0px 0px 10px #A0A0A0' }}
                />
            </div>
        )
    }
)
